import { connect } from 'react-redux'
import {
  getProductTypes,
} from 'reduxpath/ducks/ProductType/List'

import {
  setIsAddingNewItem,
  setData,
  setProductType,
} from 'reduxpath/ducks/ProductType/Add'

import {
  setEdiableData,
  updateProductType,
} from 'reduxpath/ducks/ProductType/Edit'

import {
  getServiceSelections,
} from 'reduxpath/ducks/Format/List'

import ProductTypes from './units'

const mapStateToProps = state => ({
  productTypes: state.ProductTypeList.data,
  isAddingNewItem: state.ProductTypeAdd.isAddingNewItem,
  inputValue: state.ProductTypeAdd.data.name,
  inputData: state.ProductTypeAdd.data,
  editableData: state.ProductTypeEdit.editableData,
  user: state.Auth.me.user,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(key) {
    const limit = 10
    const qs = {
      sort: 'createdAt ASC',
      limit,
      skip: key.selected * limit,
    }
    dispatch(getProductTypes(qs))
  },

  setInputFormActive(data) {
    return () => {
      dispatch(setIsAddingNewItem(data))
    }
  },

  setInputData(e) {
    const data = {
      name: e.target.value,
    }
    dispatch(setData({ data }))
  },

  onClickCancel() {
    const data = {
      name: '',
    }
    dispatch(setData({ data }))
    dispatch(setIsAddingNewItem(false))
  },

  addNewItem(inputData) {
    return () => {
      const data = {
        name: '',
      }
      dispatch(setProductType(inputData, () => {
        dispatch(setIsAddingNewItem(false))
        dispatch(setData({ data }))
        dispatch(getProductTypes({
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }))
        dispatch(getServiceSelections())
      }))
    }
  },

  selectEditableData(id, value) {
    return () => {
      const data = {
        id,
        value,
      }
      dispatch(setEdiableData(data))
    }
  },

  onChangeValueSelected(id) {
    return (e) => {
      const data = {
        id,
        value: e.target.value,
      }
      dispatch(setEdiableData(data))
    }
  },

  onConfirmEdit(id, value) {
    return () => {
      dispatch(updateProductType({ id, name: value }, id, () => {
        const data = {
          id: '',
          value: '',
        }
        dispatch(setEdiableData(data))
        dispatch(getProductTypes({
          sort: 'createdAt ASC',
          limit: 10,
          skip: 0,
        }))
      }))
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  addNewItem: dispatchProps.addNewItem(
    stateProps.inputData,
  ),
  onConfirmEdit: dispatchProps.onConfirmEdit(
    stateProps.editableData.id,
    stateProps.editableData.value,
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ProductTypes)
